import { Props_SnippetLinkBox } from './LinkBox.props'

const SnippetLinkBox = (props: Props_SnippetLinkBox) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibiity: string = heading.visibility?.value ? `snippet-link-box__heading--${heading.visibility.value}` : ''

    return (
    <section className="snippet-link-box" id={heading?.snippetid?.value || ''}>
        <div className={`snippet-link-box__container`}>
            <h2 className={`snippet-link-box__heading ${classHeadingVisibiity}`}>{ heading.content.value }</h2>
            <div className="snippet-link-box__container-entries">
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-link-box__entry`}>
                    <figure className="snippet-link-box__entry-container-image">
                        <img
                            className="snippet-link-box__entry-image"
                            loading="lazy"
                            height="300"
                            width="300"
                            src={entry.image?.value}
                            alt={entry?.alt?.value ? entry.alt.value : ''}
                        />
                    </figure>
                    <div className="snippet-link-box__entry-container-content">
                        <h3 className="snippet-link-box__entry-title">{ entry.heading?.value }</h3>
                        <a
                            className="snippet-link-box__entry-link"
                            href={entry.url?.value}
                            target={entry.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                        >
                            {entry.linkText?.value}
                        </a>
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetLinkBox